<template>
    <section class="live-list"
             id="videoTab"
             v-if="lives.length > 1">
        <div class="live-list-item"
             v-for="(item, index) in lives"
             :key="index"
             :id="item.id"
             @click="$emit('update:current', index)">
            <div class="live-item-img cover-img">
                <img :src="item.poster">
            </div>
            <span class="live-item-title">{{item.title}}</span>
            <i class="icon i-live"
               v-if="current === index">播放中</i>
            <i class="icon i-room">{{index + 1}}号直播间</i>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        current: Number,
        lives: Array
    }
}
</script>

<style scoped>
.i-live {
    right: 0;
    top: 0;
    left: unset;
    bottom: unset;
}

.list-enter-active,
.list-leave-active {
    transition: all 2s;
}
.list-enter,
.list-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
/* .list-move {
    transition: transform 1s;
} */
</style>
